import "./styles.scss";
import React, { FC, ReactNode } from "react";
import CompanyDetailLoadMore from "../CompanyDetailLoadMore/CompanyDetailLoadMore";

interface IProps {
  children?: ReactNode;
  loadMoreText?: string;
  loadMoreHasBorder: boolean;
  loadMoreHighlighted: boolean;
}

const CompanyDetailDraggable: FC<IProps> = (props: IProps): JSX.Element => {
  const { children, loadMoreText, loadMoreHasBorder, loadMoreHighlighted } =
    props;

  return (
    <div className="ps-company-detail-draggable">
      <div className="ps-company-detail-draggable__inner-container">
        {children}
      </div>

      <CompanyDetailLoadMore
        title={loadMoreText}
        hasBorder={loadMoreHasBorder}
        isHighlighted={loadMoreHighlighted}
      />
    </div>
  );
};

export default CompanyDetailDraggable;
